import PollQuestion from "./PollQuestion";

class Poll {
    pol_id: string | null | undefined
    pol_name: string | null | undefined
    pol_description: string | null | undefined

    questions: Array<PollQuestion> = []
}

export default Poll;